import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import moment from 'moment';

import { IconInfoCircle } from '@tabler/icons';

import api from '../../../services/ApiManagement/Index';
import { useOnlineStatus } from '../../../hooks/onlineStatus';

import BackHeader from '../../../components/BackHeader';
import AnimalItem from '../../../components/Animal/Item';
import Modal from '../../../components/Modal';
import {
  Skeleton,
  Label,
  H2,
  NotFoundContainer,
} from '../../../components/Generic';
import { Container, Content, RowItem, Row } from './styles';

const Sons: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [animal, setAnimal] = useState<any>({});
  const [sons, setSons] = useState<any>([]);
  const [data, setData] = useState<any>({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { id_property, id_animal }: any = useParams();
  const history = useHistory();
  const isOnline = useOnlineStatus();

  useEffect(() => {
    getAnimal();
    getSons();
  }, []);

  const getAnimal = async () => {
    try {
      const animalResponse = await api.get(
        `/animais/${id_animal}`,
        isOnline,
        'animal',
        {
          headers: {
            propriedade_id: id_property,
          },
        },
      );

      setAnimal(animalResponse.data);
    } catch (err) {
      console.log(err);
    }
  };

  const getSons = async () => {
    try {
      setLoading(true);

      const response = await api.get(
        `/animais/listar/filhos/${id_animal}`,
        isOnline,
        'animais',
        {
          headers: {
            propriedade_id: id_property,
          },
        },
      );

      setSons(response.data);
      console.log(response.data);

      if (response.data.length > 0) {
        let animalData = {
          machos: 0,
          femeas: 0,
          pesoMedio: 0,
          idadeMedia: 0,
          idadeMediaText: '',
        };
        let animalWeightCount = 0;

        response.data.map((animal: any) => {
          if (animal.sexo === 'macho') {
            animalData.machos += 1;
          } else {
            animalData.femeas += 1;
          }

          if (animal.ultimosRegistros?.peso) {
            animalWeightCount += 1;

            animalData.pesoMedio += parseFloat(
              animal.ultimosRegistros?.peso.descricao,
            );
          }

          const animalBirth = moment(animal.data_de_nascimento, 'YYYY-MM-DD');
          const age = moment().diff(animalBirth, 'days');

          animalData.idadeMedia += age;
        });

        if (animalWeightCount > 0) {
          animalData.pesoMedio =
            Math.round((animalData.pesoMedio / animalWeightCount) * 10) / 10;
        }

        animalData.idadeMedia /= response.data.length;

        if (animalData.idadeMedia > 365) {
          animalData.idadeMediaText = `${
            Math.round((animalData.idadeMedia / 365) * 10) / 10
          } anos`;
        } else {
          animalData.idadeMediaText = `${
            Math.round((animalData.idadeMedia / 31) * 10) / 10
          } meses`;
        }

        setData(animalData);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <BackHeader title="Filhos" />

      <Content>
        <AnimalItem
          gender={animal.sexo}
          name={animal.nome}
          number={animal.numero_de_identificacao}
          birth={animal.data_de_nascimento}
          imageUrl={animal.imagens?.[0]?.image_url}
          state={animal.estado}
          belongs={animal.pertencente}
          customStyle={{ marginBottom: 30 }}
        />

        <Row>
          <Label style={{ marginBottom: 10 }}>Filhos</Label>
          {sons?.length > 0 && (
            <button onClick={() => setIsModalOpen(true)}>
              mais detalhes {'>'}
            </button>
          )}
        </Row>

        {loading ? (
          <LoadingComponent />
        ) : sons?.length > 0 ? (
          sons?.map((animal: any) => (
            <AnimalItem
              imageUrl={
                animal.imagens?.length > 0 ? animal.imagens[0]?.image_url : ''
              }
              name={animal.nome}
              birth={animal.data_de_nascimento}
              number={animal.numero_de_identificacao}
              gender={animal.sexo}
              state={animal.estado}
              isPrivate={animal.privado}
              belongs={animal.pertencente}
              customStyle={{ marginTop: 20, cursor: 'pointer' }}
              onClick={() =>
                history.push(`/propriedade/${id_property}/animais/${animal.id}`)
              }
            />
          ))
        ) : (
          <NotFoundContainer>
            <IconInfoCircle size={24} />

            <strong>Nenhum filho encontrado.</strong>
          </NotFoundContainer>
        )}
      </Content>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <H2>Detalhes</H2>
        <RowItem>
          <p>Número de machos</p>
          <strong>{data?.machos}</strong>
        </RowItem>

        <RowItem>
          <p>Número de fêmeas</p>
          <strong>{data?.femeas}</strong>
        </RowItem>

        <RowItem>
          <p>Peso médio</p>
          <strong>{data?.pesoMedio && `${data?.pesoMedio}kg`}</strong>
        </RowItem>

        <RowItem>
          <p>Idade média</p>
          <strong>{data?.idadeMediaText && data?.idadeMediaText}</strong>
        </RowItem>
      </Modal>
    </Container>
  );
};

const LoadingComponent = () => (
  <>
    <Skeleton
      style={{
        marginBottom: 20,
        height: 42,
        width: '100%',
        borderRadius: 8,
      }}
    />
    <Skeleton
      style={{
        marginBottom: 20,
        height: 42,
        width: '100%',
        borderRadius: 8,
      }}
    />
    <Skeleton
      style={{
        marginBottom: 20,
        height: 42,
        width: '100%',
        borderRadius: 8,
      }}
    />
    <Skeleton
      style={{
        marginBottom: 20,
        height: 42,
        width: '100%',
        borderRadius: 8,
      }}
    />
  </>
);

export default Sons;
